import React from 'react';

export default React.createContext({ isScrolling: false });
